'use client'

import LinkButton from '@/components/router/LinkButton'
import { ScheduleListItem } from '@/components/schedule/GameSchedule'
import Button from '@/components/ui-other/basic/Button'
import { ComponentType, useState } from 'react'
import { ChevronDown, ChevronUp } from 'react-feather'
import { Game, GameState } from 'types'
// import PushIcon from 'public/img/ci-icons/pushnachrichten.svg';
import LivePlayIcon from 'public/img/ci-icons/live-play.svg'
// import KalenderIcon from 'public/img/ci-icons/kalender.svg'
import { ListItemDetail } from '@/components/newSchedule/ListItemDetail'
import { getDateLabel } from './getDateLabel'

export const ListItemMobile: ComponentType<{ game: Game }> = ({ game }) => {
  const [detailsOpen, setDetailsOpen] = useState<boolean>(false)

  const toggleDetailsOpen = () => {
    setDetailsOpen(!detailsOpen)
  }

  const liveOrPastGame =
    game.state === GameState.LIVE || game.state == GameState.POST

  return (
    <div
      className={`scale-100 @xl/schedule:hidden block bg-white p-4 align-middle items-center ${
        detailsOpen ? 'ring-2 ring-primary shadow-lg relative' : 'shadow-none'
      }`}
    >
      {/* <Link className="block" href={gamePath(game)}>  // nested link causes hydrate error */}
      <div className="flex justify-between items-center">
        <div className={`font-bold ${liveOrPastGame ? 'mb-2' : 'mb-4'}`}>
          {getDateLabel(game.startsAt, game.state)}
        </div>
        <div className="flex justify-end">
          {game.livestreamUrl && (
            <LinkButton
              href={game.livestreamUrl}
              openInNewWindow={true}
              iconOnly
              color="white"
              tooltip="zum Livestream"
            >
              <LivePlayIcon />
            </LinkButton>
          )}
          {/* <Button iconOnly color="white" tooltip="Kalender abonnieren">
            <KalenderIcon />
          </Button> */}
          <Button
            onClick={toggleDetailsOpen}
            iconOnly
            color={'white'}
            tooltip={detailsOpen ? 'Details schließen' : 'Details öffnen'}
          >
            {detailsOpen ? (
              <ChevronUp />
            ) : (
              <>
                <ChevronDown />
              </>
            )}
          </Button>
        </div>
      </div>
      <ScheduleListItem showPhase={true} game={game} />
      {/* <div className="flex flex-col justify-between items-center w-full">
          <div className="flex w-full justify-between">
            <div className="space-y-px">
              <div className="flex gap-4 py-1">
                <Image
                  className="w-6 h-6"
                  src={checkLogo(game.homeTeam.logo, 'club')}
                  alt={`Logo ${game.homeTeam.name}`}
                  objectFit="contain"
                />
                <div className=" truncate " title={game.homeTeam.name}>
                  {game.homeTeam.name}
                </div>
              </div>

              <div className="flex gap-4 py-1">
                <Image
                  className="w-6 h-6"
                  src={checkLogo(game.awayTeam.logo, 'club')}
                  alt={`Logo ${game.awayTeam.name}`}
                  objectFit="contain"
                />
                <div className="truncate" title={game.awayTeam.name}>
                  {game.awayTeam.name}
                </div>
              </div>
            </div>
            {(game.state === GameState.LIVE || game.state == GameState.POST) && (
              <div className="space-y-[1px]">
                <div className="py-1 px-2 min-w-[3.5rem] text-white bg-black rounded-t-md text-center">
                  {game.homeGoals}
                </div>
                <div className=" py-1 px-2 min-w-[3.5rem] text-white bg-black rounded-b-md text-center">
                  {game.awayGoals}
                </div>
              </div>
            )}
            {game.state !== GameState.LIVE && game.state !== GameState.POST && (
              <ScoreBox className='min-w-[3.5rem]' game={game} />
            )}
          </div>
        </div> */}
      {/* </Link> // nested link causes hydrate error  */}

      <div className={detailsOpen ? 'block' : 'hidden'}>
        <hr className="text-gray-500 w-full mt-4 mb-4" />
        <ListItemDetail game={game} />
      </div>
    </div>
  )
}
